exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Root___1SOz8 {\n  background-color: var(--color-forget-badge-background);\n  color: var(--color-forget-text);\n  padding-right: 1.75em;\n  position: relative;\n}\n\n.Root___1SOz8::after {\n  bottom: 0;\n  content: '\\2728';\n  position: absolute;\n  right: 0.25em;\n}\n", ""]);

// exports
exports.locals = {
	"Root": "Root___1SOz8"
};